module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("5kUI8"))).then(() => parcelRequire('89uEU'));